import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import './helpers/dayjs';
import { store } from './helpers/store/configureStore';
import reportWebVitals from './reportWebVitals';

async function enableMocking() {
  if (process.env.REACT_APP_MOCKS_ENABLED !== 'true') {
    return;
  }

  const { worker } = await import('mocks/browser');

  return worker.start();
}

async function main() {
  await enableMocking();

  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );

  /*
   * If you want to start measuring performance in your app, pass a function
   * to log results (for example: reportWebVitals(console.log))
   * or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
   */

  reportWebVitals();
}

main().then();
